import React, { useContext } from 'react';

import MaterialGrid from '@mui/material/Grid/Grid';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';

import {
  MaterialButton,
  MaterialDialog,
  MaterialDialogActions,
  MaterialDialogContent,
  MaterialDialogTitle,
  MaterialMobile,
  MaterialTextField,
} from '../../../index';
import MaterialTypography from '../../MaterialTypography/MaterialTypography';
import { useContactForm } from './useContactForm';

const ContactForm = (props) => {
  const { actions } = useContext(MainContext);
  const { t } = useTranslation();
  const { open, onClose, sendContactFormData, icon } = useContactForm(props);

  return (
    <MaterialDialog
      shouldAutoFocusCloseButton={false}
      className="contactFromDialog"
      variant="medium"
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="contact-form-dialog-title"
    >
      <MaterialDialogTitle
        disableTypography
        icon={<img className="dialogTitleIcon" src={icon?.src} alt={icon?.alt} />}
        withDivider={false}
        onClose={onClose}
      >
        <MaterialTypography id="contact-form-dialog-title" variant="h2">
          {t('contactForm.title')}
        </MaterialTypography>
      </MaterialDialogTitle>

      <MaterialDialogContent>
        <MaterialGrid container direction="column" rowSpacing={3}>
          <MaterialGrid item>
            <MaterialTextField
              readOnly={!!actions.case.getCaseValue('applicant.fullName.firstName')}
              value={actions.case.getCaseValue('applicant.fullName.firstName') || undefined}
              name="contactForm.fullName.firstName"
              className="widget"
              fullWidth
              autoFocus
            />
          </MaterialGrid>
          <MaterialGrid item>
            <MaterialTextField
              readOnly={!!actions.case.getCaseValue('applicant.fullName.lastName')}
              value={actions.case.getCaseValue('applicant.fullName.lastName') || undefined}
              name="contactForm.fullName.lastName"
              className="widget"
              fullWidth
            />
          </MaterialGrid>
          <MaterialGrid item>
            <MaterialTextField
              readOnly={!!actions.case.getCaseValue('applicant.identifier')}
              value={actions.case.getCaseValue('applicant.identifier') || undefined}
              name="contactForm.id"
              className="widget"
              fullWidth
            />
          </MaterialGrid>
          <MaterialGrid item>
            <MaterialMobile
              name="contactForm.phone"
              value={actions.case.getCaseValue('applicant.mobile.phone') || undefined}
              className="widget"
              fullWidth
            />
          </MaterialGrid>
          <MaterialGrid item>
            <MaterialTextField name="contactForm.description" multiline fullWidth />
          </MaterialGrid>
        </MaterialGrid>
      </MaterialDialogContent>
      <MaterialDialogActions>
        <MaterialButton fullWidth onClick={sendContactFormData}>
          {t('contactForm.button.label')}
        </MaterialButton>
      </MaterialDialogActions>
    </MaterialDialog>
  );
};

export default ContactForm;
